/*!
 * Stimpack Control - Select
 *
 * @version : 1.0.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlSelect = function(root, options)
    {
        var _t = this,
            root = $(root);

        this.o = $.extend({
            theme               : 'stimpack',

            dropdownAutoHeight  : false,
            ajaxCallback        : null,
            //resultTemplate      : '',
            //selectionTemplate   : '',

        }, options);


        if (this.o.ajaxCallback)
        {
            if (typeof this.o.ajaxCallback == 'string' && this.o.ajaxCallback.indexOf('{') == 1)
            {
                this.o.ajaxCallback = JSON.parse(this.o.ajaxCallback);
            }

            if (typeof this.o.minimumInputLength == 'undefined')
            {
                this.o.minimumInputLength = 1;
            }

            this.o.ajax = {
                url         : STIMPACK.ajaxUrl,
                dataType    : 'json',
                data        : function (params) {

                    if (typeof _t.o.ajaxCallback == 'object')
                    {
                        _t.o.ajaxCallback.s = params.term;
                        return _t.o.ajaxCallback;
                    }
                    else
                    {
                        return {
                            action  : _t.o.ajaxCallback,
                            s       : params.term
                        };
                    }
                },
                processResults : function (data, params) {
                    return {
                        results: data.items
                    };
                }
            };
        }

        if (this.o.resultTemplate)
        {
            this.o.templateResult = function(item) {
                return _t.renderResult(item);
            };
        }

        if (this.o.selectionTemplate)
        {
            this.o.templateSelection = function(item) {
                return _t.renderSelection(item);
            };
        }

        this.el = {
            root            : root,
            select          : root.find('select'),
            encodedOutput   : root.find('.sp-control-select-encoded-output')
        };

        this.el.select.on('change.select2', function (e) {
            _t.refresh();
        });

        this.el.select.on('select2:open', function (e, data) {
            setTimeout(function() {_t.updateDropdown();}, 10);
        });

        $(window).resize(function (e, data) {
            setTimeout(function() {_t.updateDropdown();}, 10);
        });

        this.el.select.select2(this.o);

        this.refresh();
    };

    /*
     * Get value
     */
    spControlSelect.prototype.updateDropdownHeight = function()
    {
        var dropdown = this.o.dropdownParent ? $(this.o.dropdownParent).find('.select2-dropdown') : $('.select2-dropdown'),
            list = dropdown.find('.select2-results > ul'),
            availableHeight = 0,
            offset = 15;

        if (list.length > 0)
        {
            if (list.is(':visible'))
            {
                if (dropdown.hasClass('select2-dropdown--above'))
                {
                    availableHeight = (list.offset().top - $(window).scrollTop()) + list.outerHeight();
                }
                else
                {
                    availableHeight = $(window).outerHeight() - (list.offset().top - $(window).scrollTop());
                }

                list.css('max-height', availableHeight - offset);
                dropdown.addClass('sp-control-select-dropdown-auto-height');
            }
            else
            {
                list.css('max-height', 'none');
                dropdown.removeClass('sp-control-select-dropdown-auto-height');
            }
        }
    }

    /*
     * Get value
     */
    spControlSelect.prototype.updateDropdown = function()
    {
        this.updateDropdownHeight();
    }


    /*
     * Get value
     */
    spControlSelect.prototype.renderTemplate = function(template, variables)
    {
        var output = template;

        $.each(variables, function(key, value) {
            output = output.replace('{{ ' + key + ' }}', value);
        });

        return output;
    }

    /*
     * Get value
     */
    spControlSelect.prototype.renderResult = function(result)
    {
        if (result.loading)
        {
            return result.text;
        }

        var output = this.renderTemplate(this.o.resultTemplate, result);

        return $(output);
    }


    /*
     * Get value
     */
    spControlSelect.prototype.renderSelection = function(selection)
    {
        return this.renderTemplate(this.o.selectionTemplate, selection);
    }


    /*
     * Get value
     */
    spControlSelect.prototype.getValue = function()
    {
        var value = this.el.select.select2("val");

        if (typeof value === 'string')
        {
            value = [value];
        }

        return value;
    };


    /*
     * Refresh
     */
    spControlSelect.prototype.refresh = function()
    {
        var value = this.getValue();

        this.el.root.attr('sp-control-select-value', value);
        this.updateEncodedOutput(value);
    }

    /*
     * Update json output
     */
    spControlSelect.prototype.updateEncodedOutput = function(value)
    {
        if (this.el.encodedOutput.length > 0)
        {
            if (value)
            {
                value = spBase64Encode(typeof value === 'object' ? JSON.stringify(value) : null);
            }

            this.el.encodedOutput.val(value);
        }
    }

    $.fn.spControlSelect = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-select');

            $(this).attr('data-sp-control-select', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlSelect = new spControlSelect(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-select]').each(function() {
        $(this).spControlSelect();
    });

})(jQuery);
